export default "__VITE_ASSET__CLyAek$$__"